if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled()) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        const whatsappLink = this.querySelector('[data-newsletter-whatsapp]');
        if (whatsappLink) {
          const dismissForWhatsApp = () => this.hide();
          whatsappLink.addEventListener('click', dismissForWhatsApp);
          this.registerCleanup(() => whatsappLink.removeEventListener('click', dismissForWhatsApp));
        }
        this.registerCleanup(() => clearTimeout(this.showTimer));
        if (!this.testMode && this.querySelector('.alert--success')) {
          this.setCookie(this.cookieName, 365);
        }
        
        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }
    
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        const showWhenReady = () => {
          if (!this.isConnected || this.open) return;
          if (!this.submited && !this.testMode && this.getCookie(this.cookieName)) return;
          const consentOpen = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')].some((element) => {
            const style = getComputedStyle(element);
            return element.getClientRects().length > 0 && style.visibility !== 'hidden' && style.display !== 'none';
          });
          const otherModalOpen = [...document.querySelectorAll('.drawer[open], .x-modal[open], dialog[open]')].some((element) => element !== this);
          const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
          if (document.hidden || consentOpen || otherModalOpen || editing) {
            this.showTimer = setTimeout(showWhenReady, 1000);
            return;
          }
          this.show();
        };
        this.showTimer = setTimeout(showWhenReady, delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.querySelector('.alert--success') ? 365 : this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/; SameSite=Lax`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0; path=/; SameSite=Lax`;
      }
    }
  );
}
